import { useOptionName as useName } from "@/components/features/items/edit/option/_shared/ui/components/name/hooks/use-name";

import { useProductOptionI18nFormModelContext } from "../../../../context";

export const useOptionI18nName = () => {
	const { viewModel, onSetViewModel } = useProductOptionI18nFormModelContext();
	const { name } = viewModel;

	return useName({ name, onSetViewModel });
};
